var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-block",class:_vm.type_msg},[(_vm.isText)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),_vm._l((_vm.text),function(item_text,index){return (_vm.isArray)?_c('p',{key:index},[_vm._v(_vm._s(item_text))]):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbd83d6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/msg.vue
// module id = null
// module chunks = 